// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__8rZL5","main":"MainLayout_main__R8-6P","collapsed":"MainLayout_collapsed__MpMl4"};